const ExcelIcon = () => {
  return (
    <svg
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2345 22.6399C17.2342 23.0005 17.0908 23.3463 16.8358 23.6013C16.5808 23.8563 16.235 23.9997 15.8743 24H1.36124C1.0006 24 0.654686 23.8569 0.399465 23.6021C0.144245 23.3473 0.000574714 23.0016 4.32176e-07 22.6409V1.3986C-0.000142096 1.2198 0.0349701 1.04272 0.103328 0.877504C0.171687 0.712286 0.27195 0.562167 0.398381 0.435735C0.524813 0.309303 0.674932 0.20904 0.84015 0.140681C1.00537 0.0723231 1.18244 0.0372114 1.36124 0.0373539H10.6754L17.2345 6.72652V22.6399Z"
        fill="#23A566"
      />
      <path
        d="M11.3984 6.55126L17.2357 12.1306V6.68674H12.065C11.8392 6.68929 11.6167 6.63328 11.419 6.52417L11.3984 6.55126Z"
        fill="#1C8F5A"
      />
      <path
        d="M17.2355 6.71518H12.0506C11.6899 6.71489 11.3441 6.5715 11.0891 6.31648C10.8341 6.06146 10.6907 5.71567 10.6904 5.35502V0L17.2355 6.71518Z"
        fill="#8ED1B1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.0866 19.5824H4.11816V11.8062H13.0866V19.5824ZM9.15997 12.9279V14.2891H11.9843V12.93L9.15997 12.9279ZM9.15997 15.1464V16.4469H11.9843V15.1399L9.15997 15.1464ZM9.15997 17.2761V18.4801H11.9843V17.2695L9.15997 17.2761ZM8.05125 18.4736V17.2695H5.22797V18.4736H8.05125ZM8.05125 16.4329V15.1399H5.22797V16.4394L8.05125 16.4329ZM8.05125 14.3032V12.9279H5.22797V14.2891L8.05125 14.3032Z"
        fill="white"
      />
    </svg>
  );
};

export default ExcelIcon;
